import Filter from '@components/Filter';
import { useAtom } from 'jotai';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { itemColumnsAtom, itemFilterAtom } from '../../../atoms/itemFilterAtoms';

function ItemFilters() {
    const [filters, setFilters] = useAtom(itemFilterAtom);
    const [columns, setColumns] = useAtom(itemColumnsAtom);
    const { t } = useTranslation('items');
    const options = [t('filter.excludeSoldOut')]
        .map((it) => ({ value: '품절상품 제외', label: it }));
    return (
        <Filter title={t('filter.title')}
            sort={`${columns}`}
            setSort={(v) => setColumns(Number(v))}
            sortItems={[
                { value: '2', label: t('filter.twoColumns') },
                { value: '3', label: t('filter.threeColumns') },
            ]}
            filters={filters}
            setFilters={setFilters}
            filterItems={options} />
    );
}

export default ItemFilters;
